export enum ValidateAddressErrorCodes {
  BS102 = 'BS102',
  BS103 = 'BS103',
}
